export enum BillType {
    OPDBill = 1,
    IPDBill = 2,
    Estimate = 3,
    PharmacyBill = 4
}
export const BillTypeLabels: Record<BillType, string> = {
    [BillType.OPDBill]: "OPDBill",
    [BillType.IPDBill]: "IPDBill",
    [BillType.Estimate]: "Estimate",
    [BillType.PharmacyBill]: "PharmacyBill",
};
